import React from "react";
import {
  Container,
  Content,
  ConversationHeaderWrapper,
  ConversationHeader,
  ConversationHeaderLeft,
  MessagesList,
  MessageBubble,
  SecondContainer,
} from "../../ChatPanel.styled";
import { Typography, ChatInput, ButtonMenu, Icon } from "@ann/web-components";
import { useStore } from "../../../../../../../hooks";
import { CHAT_INPUT_ADD_MENU_ITEMS } from "../../constants";

const ConversationView = ({
  messages,
  attachments,
  onFilesSelected,
  onAttachmentRemove,
  onAddMenuChange,
  onModeMenuChange,
}) => {
  const { chatStore } = useStore();
  const agentName = chatStore.selectedAgent?.name ?? "Agent";
  const modelLabel = chatStore.selectedAgent?.metadata?.model
    ? `Model ${chatStore.selectedAgent.metadata.model}`
    : "Model GPT 5.2";

  return (
    <Container>
      <Content>
        <ConversationHeaderWrapper>
          <ConversationHeader>
            <ConversationHeaderLeft>
              <Typography category="title" size="medium" weight="bold" color="body">
                {agentName}
              </Typography>
              <Typography category="caption" size="small" weight="regular" color="body">
                {modelLabel}
              </Typography>
              <ButtonMenu
                alignMenu="right"
                customIcon="dotsMenu"
                iconPosition="right"
                label=""
                menuPosition="bottom"
                onChange={() => {}}
                size="medium"
                type="tertiary"
                usePortal
                width="auto"
                disableEffects
              >
                <ButtonMenu.Menu icon={true}>
                  <ButtonMenu.Item label="New chat" value="new_chat" icon="edit_square">
                    New chat
                  </ButtonMenu.Item>
                  <ButtonMenu.Item
                    label="View past conversations"
                    value="view_past_conversations"
                    icon="history"
                  >
                    View past conversations
                  </ButtonMenu.Item>
                  <ButtonMenu.Item label="Edit Agent" value="edit_agent" icon="edit_square">
                    Edit Agent
                  </ButtonMenu.Item>
                  <ButtonMenu.Item label="Delete chat" value="delete_chat" icon="delete">
                    Delete chat
                  </ButtonMenu.Item>
                </ButtonMenu.Menu>
              </ButtonMenu>
            </ConversationHeaderLeft>
            <Icon color="neutral" name="search" size="medium" />
          </ConversationHeader>
          <MessagesList>
            {messages.map((msg, index) => (
              <MessageBubble key={index} $isUser={msg.role === "user"}>
                <Typography category="body" size="medium" weight="regular">
                  {msg.content}
                </Typography>
              </MessageBubble>
            ))}
          </MessagesList>
        </ConversationHeaderWrapper>
        <SecondContainer>
          <ChatInput
            className={"chat-input"}
            placeholder="Ask anything"
            allowUploadFiles
            attachments={attachments}
            onFilesSelected={onFilesSelected}
            onAttachmentRemove={onAttachmentRemove}
            onAddMenuChange={onAddMenuChange}
            onModeMenuChange={onModeMenuChange}
            addMenuItems={CHAT_INPUT_ADD_MENU_ITEMS}
            isProcessing={false}
          />
        </SecondContainer>
      </Content>
    </Container>
  );
};

export default ConversationView;
